module.exports = __webpack_public_path__ + "static/barmej-logo-43bd3b712b8cea31471e3697faa0f98b.svg";